/*
Le js chargé par notre page html, qui va charger jcas
 */

import jCasLoad from 'jcas/src/js/jCasLoad.js'

function init () {
  jCasLoad({ container: 'main', giacUrl: 'lib/giacwasm.js' })
    .catch(error => console.error(error))
}

// initialisation au chargement
if (document.readyState === 'loading') {
  window.addEventListener('DOMContentLoaded', init)
} else {
  init()
}
